export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive MMA Coach Ready?',
    a: 'You receive digital access after your purchase is completed. The materials are delivered in PDF format and can be accessed from compatible devices.',
  },
  {
    q: 'Is this an app?',
    a: 'No. MMA Coach Ready is a digital PDF-based coaching system.',
  },
  {
    q: 'Does it include videos?',
    a: 'No. The system is built around highly visual PDF coaching resources, diagrams, progressions and ready-to-use session structures.',
  },
  {
    q: 'Is the material in English?',
    a: 'Yes. MMA Coach Ready is provided in English.',
  },
  {
    q: 'Can I edit the files?',
    a: 'No. The materials are delivered as finished PDF resources.',
  },
  {
    q: 'Is this only for beginner coaches?',
    a: 'No. The system is designed to support coaches working from beginner through advanced athlete development.',
  },
  {
    q: 'Is this just a striking or grappling product?',
    a: 'No. MMA Coach Ready is designed around the complete MMA pathway, including striking, clinch, takedowns, ground control, scrambles and full-phase integration.',
  },
  {
    q: 'Is this connected to UFC?',
    a: 'No. MMA Coach Ready is an independent coaching resource and is not affiliated with UFC or any professional fighting promotion.',
  },
]
